export const ORDERS_BASE_URL = '/v2/orders';
export const SAVED_SEARCHES_BASE_URL = '/v1/saved-searches';

export const PENDING_ORDERS_URL = `${ORDERS_BASE_URL}/pending`;
export const FETCH_TOTAL_ORDERS = `${ORDERS_BASE_URL}/total`;
export const EXPORT_ORDERS = `${ORDERS_BASE_URL}/export`;
export const FETCH_ORDERS_FILTERS = `${ORDERS_BASE_URL}/filters`;
export const ORDERS_BOUNCED_EMAILS_URL = `${ORDERS_BASE_URL}/:id/bounced-emails`;
export const FETCH_MULTIPLE_COUNTS_ORDERS = `${ORDERS_BASE_URL}/counts`;
export const FETCH_ORDERS_AUTO_CANCEL_CONFIG = `${ORDERS_BASE_URL}/auto-cancel`;
export const FETCH_SAVED_SEARCHES = `${SAVED_SEARCHES_BASE_URL}`;
export const CREATE_SAVED_SEARCH = `${SAVED_SEARCHES_BASE_URL}`;
export const UPDATE_SAVED_SEARCH = `${SAVED_SEARCHES_BASE_URL}`;
export const CONFIGURE_SAVED_SEARCHES = `${SAVED_SEARCHES_BASE_URL}`;
